
import React from "react";
import { FormFieldType } from "@/types/form";
import {
  TextField,
  EmailField,
  UrlField,
  TextareaField,
  CheckboxField,
  RadioField,
  SelectField,
  DateField,
  FileField,
  SectionHeader,
  Instruction,
  TimePickerField,
  StudentSearchField,
  TeacherSearchField,
  RichTextInstructionField,
  PreviousReportButton
} from "./fields";
import { WorksheetSearchField, NextTopicWorksheetSearchField } from "./fields/WorksheetSearch";

interface FormFieldProps {
  element: FormFieldType;
}

export const FormField: React.FC<FormFieldProps> = ({ element }) => {
  const renderField = () => {
    switch (element.type) {
      case "text":
        return <TextField element={element} />;
      
      case "email":
        return <EmailField element={element} />;
      
      case "url":
        return <UrlField element={element} />;
      
      case "textarea":
        return <TextareaField element={element} />;
      
      case "checkbox":
        return <CheckboxField element={element} />;
      
      case "radio":
        return <RadioField element={element} />;
      
      case "select":
        return <SelectField element={element} />;
      
      case "date":
        return <DateField element={element} />;
      
      case "file":
        return <FileField element={element} />;
      
      case "section_header":
        return <SectionHeader element={element} />;
      
      case "instruction":
        return <Instruction element={element} />;
        
      case "rich_text_instruction":
        return <RichTextInstructionField element={element} />;
        
      case "time_picker":
        return <TimePickerField element={element} />;
      
      case "student_search":
        return <StudentSearchField element={element} />;
      
      case "teacher_search":
        return <TeacherSearchField element={element} />;
        
      case "previous_report_button":
        return <PreviousReportButton element={element} />;
        
      case "worksheet_search":
        // Check if this is for next topic
        if (element.id === "next_topic_worksheet_search") {
          return <NextTopicWorksheetSearchField element={element} />;
        }
        return <WorksheetSearchField element={element} />;
        
      default:
        return <p>Unsupported field type: {element.type}</p>;
    }
  };

  return (
    <div className="mb-6">
      {renderField()}
    </div>
  );
};

export default FormField;
